export default {
    formId: 'cotizarForm',
    formField: {
        afinidad: {
            name: 'afinidad',
            label: 'Afinidad',
            requiredErrorMsg: 'Debe especificar la afinidad a la que pertenece el titular'
        },
        img_afinidad:{
            name: 'img_afinidad',
            label: 'img_afinidad',
        },
        motovehiculo: {
            marca: {
                name: 'motovehiculo.marca',
                label: 'Marca',
                requiredErrorMsg: 'Debe especificar la marca del vehículo'
            },
            anio: {
                name: 'motovehiculo.anio',
                label: 'Año',
                requiredErrorMsg: 'Debe especificar el año del vehículo'
            },
            version: {
                name: 'motovehiculo.version',
                label: 'Versión',
                requiredErrorMsg: 'Debe especificar el modelo del vehículo'
            },
            valorAdicional: {
                name: 'motovehiculo.valorAdicional',
                label: 'Valor adicional (accesorios)',
                requiredErrorMsg: 'Debe especificar un valor (puede ser cero)'
            },
            usoVehiculo: {
                name: 'motovehiculo.usoVehiculo',
                label: 'Tipo de uso',
                requiredErrorMsg: ''
            },
            ceroKm: {
                name: 'motovehiculo.ceroKm',
                label: '¿0 Km?',
                requiredErrorMsg: ''
            },
        },
        situacionImpositiva: {
            name: 'situacionImpositiva',
            label: 'Situación impositiva*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        tipoPersona: {
            name: 'tipoPersona',
            label: 'Tipo persona*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        codigosLocalidad: {
            name: 'codigosLocalidad',
            label: 'Código postal / Localidad*',
            requiredErrorMsg: 'Debe especificar una localidad'
        },
        vigencia: {
            name: 'vigencia',
            label: 'Vigencia*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        fechaVigencia: {
            name: 'fechaVigencia',
            label: 'Desde',
            requiredErrorMsg: 'Debe especificar una fecha'
        },
        descuentoModelo: {
            name: 'descuentoModelo',
            label: 'Porcentaje de Descuento',
            requiredErrorMsg: 'Debe especificar un porcentaje de descuento'
        },
        frecuenciaPago: {
            name: 'frecuenciaPago',
            label: 'Frecuencia de pago*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        cuotas: {
            name: 'cuotas',
            label: 'Cantidad de cuotas*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        ajusteAutomatico : {
            name: 'ajusteAutomatico',
            label: 'Ajuste automático',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        equipoTelematica : {
            name: 'equipoTelematica',
            label: 'Equipo telemática',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },


        //NOT USED FOR NOW
        sumaAsegurada: {
            name: 'sumaAsegurada',
            label: 'Suma asegurada*',
            requiredErrorMsg: 'Debe indicar la suma asegurada'
        },
        fechaCotizacion: {
            name: 'fechaCotizacion',
            label: 'Fecha de cotización*',
            requiredErrorMsg: 'Debe indicar la fecha de cotización'
        },
        zonaRiesgo: {
            name: 'zonaRiesgo',
            label: 'Zona de riesgo',
        }
    }
};
